/**
 * Custom Mega Menu – opens on hover over matching header nav item.
 * Hides default dropdown for that item; keeps header is-megamenu-open while panel or dropdown is hovered.
 */
(function () {
  const header = document.querySelector('#header');
  const megaNav = document.querySelector('nav.js-nav, .js-mega-menu');
  if (!header || !megaNav) return;

  function normalizeTrigger(t) {
    return (t || '').trim();
  }

  /** Menü başlığı eşleştirmesi: boşluk, apostrof/tırnak farkları yüzünden eşleşmeme olmasın */
  function normalizeForMatch(s) {
    if (s == null || typeof s !== 'string') return '';
    var t = s.trim().replace(/\s+/g, ' ');
    var apostrophes = /[\u2018\u2019\u201A\u201B\u2032\u2035']/g;
    return t.replace(apostrophes, "'");
  }

  /** Handleize benzeri: drawer data-menu eşleşmesi için (apostrof farkı olabilir) */
  function toHandle(s) {
    var n = normalizeForMatch(s);
    return n.toLowerCase().replace(/\s+/g, '-').replace(/[''\u2018\u2019\u201A\u201B\u2032\u2035]/g, '').replace(/[^a-z0-9-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  }

  function getPanels() {
    return document.querySelectorAll('.js-custom-megamenu-panel[data-megamenu-trigger]');
  }

  function getNavItems() {
    return megaNav.querySelectorAll('.header__nav-item[data-menu-item]');
  }

  function toggleHeaderMegamenuOpen() {
    const hasVisibleDropdown = megaNav.querySelector('.js-dropdown.is-visible');
    const hasVisibleCustomPanel = document.querySelector('.js-custom-megamenu-panel.is-visible');
    if (hasVisibleDropdown || hasVisibleCustomPanel) {
      header.classList.add('is-megamenu-open');
    } else {
      header.classList.remove('is-megamenu-open');
    }
  }

  function closeAllDefaultDropdowns() {
    megaNav.querySelectorAll('.js-dropdown.is-visible').forEach(function (dropdown) {
      dropdown.classList.remove('is-visible');
    });
    megaNav.querySelectorAll('.header__nav-sublinks.is-visible').forEach(function (el) {
      el.classList.remove('is-visible');
    });
  }

  function closeAllCustomPanels() {
    getPanels().forEach(function (panel) {
      panel.classList.remove('is-visible');
      panel.setAttribute('aria-hidden', 'true');
    });
  }

  function bindPanelToNavItem(panel, navItem) {
    const trigger = panel.getAttribute('data-megamenu-trigger');
    if (!trigger) return;

    navItem.classList.add('has-custom-megamenu');

    /* Menüden panele geçerken boşluğa düşmemek için kapanmayı geciktir */
    var leaveTimeout = null;

    navItem.addEventListener('mouseenter', function () {
      if (leaveTimeout) {
        clearTimeout(leaveTimeout);
        leaveTimeout = null;
      }
      closeAllDefaultDropdowns();
      closeAllCustomPanels();
      panel.classList.add('is-visible');
      panel.setAttribute('aria-hidden', 'false');
      toggleHeaderMegamenuOpen();
    });

    navItem.addEventListener('mouseleave', function (e) {
      const related = e.relatedTarget;
      if (related && panel.contains(related)) return;
      if (related && isMovingToMegamenuArea(related)) return;
      if (leaveTimeout) clearTimeout(leaveTimeout);
      leaveTimeout = setTimeout(function () {
        leaveTimeout = null;
        closeAllCustomPanels();
        closeAllDefaultDropdowns();
        toggleHeaderMegamenuOpen();
      }, 280);
    });

    panel.addEventListener('mouseenter', function () {
      if (leaveTimeout) {
        clearTimeout(leaveTimeout);
        leaveTimeout = null;
      }
      panel.classList.add('is-visible');
      panel.setAttribute('aria-hidden', 'false');
      header.classList.add('is-megamenu-open');
    });

    panel.addEventListener('mouseleave', function (e) {
      const related = e.relatedTarget;
      if (related && navItem.contains(related)) return;
      if (related && isMovingToMegamenuArea(related)) return;
      if (leaveTimeout) clearTimeout(leaveTimeout);
      leaveTimeout = setTimeout(function () {
        leaveTimeout = null;
        closeAllCustomPanels();
        closeAllDefaultDropdowns();
        toggleHeaderMegamenuOpen();
      }, 200);
    });
  }

  function closeAllAndResetHeader() {
    closeAllCustomPanels();
    closeAllDefaultDropdowns();
    header.classList.remove('is-megamenu-open');
  }

  /** Fare bir mega panele veya başka bir mega menü nav öğesine gidiyorsa true */
  function isMovingToMegamenuArea(related) {
    if (!related) return false;
    if (related.closest && related.closest('.js-custom-megamenu-panel')) return true;
    if (related.closest && related.closest('.header__nav-item.has-custom-megamenu')) return true;
    return false;
  }

  /** Mobil drawer: mega menülü öğe için panel yoksa panel oluştur ve ana menüde buton+chevron göster */
  function ensureDrawerPanelAndButton(drawer, handle, trigger) {
    var drawerPanel = drawer.querySelector('.menu-panel[data-menu="' + handle + '"]');
    if (drawerPanel) return drawerPanel;

    var primaryList = drawer.querySelector('.primary-menu-panel ul');
    if (!primaryList) return null;

    var triggerNorm = normalizeForMatch(trigger);
    var listItems = primaryList.querySelectorAll('li');
    var targetLi = null;
    var linkOrButton = null;
    for (var i = 0; i < listItems.length; i++) {
      var li = listItems[i];
      var link = li.querySelector('a.h4, a[href], button.menu-link');
      if (!link) continue;
      var text = (link.textContent || '').trim();
      if (normalizeForMatch(text) === triggerNorm) {
        targetLi = li;
        linkOrButton = link;
        break;
      }
    }

    if (targetLi && linkOrButton) {
      if (linkOrButton.tagName === 'A') {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'menu-link h4';
        btn.setAttribute('data-ref', handle);
        btn.textContent = linkOrButton.textContent.trim();
        var iconWrap = document.createElement('span');
        iconWrap.className = 'icon';
        var existingIcon = drawer.querySelector('.menu-link .icon');
        if (existingIcon) {
          iconWrap.innerHTML = existingIcon.innerHTML;
        } else {
          iconWrap.innerHTML = '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 4L17 12L9 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
        }
        btn.appendChild(document.createTextNode('\n'));
        btn.appendChild(iconWrap);
        targetLi.replaceChild(btn, linkOrButton);
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var targetPanel = document.querySelector('.menu-panels .menu-panel[data-menu="' + handle + '"]');
          if (!targetPanel) return;
          ensureDrawerPanelContent(targetPanel, handle);
          var primaryMenuPanel = document.querySelector('.primary-menu-panel');
          var allPanels = document.querySelectorAll('.menu-panels .menu-panel');
          if (!primaryMenuPanel) return;
          allPanels.forEach(function (p) {
            p.classList.remove('is-active');
            p.style.opacity = '';
          });
          primaryMenuPanel.style.opacity = '0';
          targetPanel.classList.add('is-active');
          targetPanel.style.opacity = '1';
        });
      }
    }

    var panel = document.createElement('div');
    panel.className = 'menu-panel';
    panel.setAttribute('data-menu', handle);
    var backBtn = document.createElement('button');
    backBtn.type = 'button';
    backBtn.className = 'menu-link menu-header';
    var backIcon = drawer.querySelector('.menu-link.menu-header .icon');
    if (backIcon) {
      var backIconClone = backIcon.cloneNode(true);
      backIconClone.classList.add('icon--rotate-180');
      backBtn.appendChild(backIconClone);
    } else {
      var backSvg = document.createElement('span');
      backSvg.className = 'icon icon--rotate-180';
      backSvg.innerHTML = '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 4L17 12L9 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
      backBtn.appendChild(backSvg);
    }
    backBtn.appendChild(document.createTextNode(trigger || ''));
    backBtn.addEventListener('click', function () {
      var primaryMenuPanel = document.querySelector('.primary-menu-panel');
      var allPanels = document.querySelectorAll('.menu-panels .menu-panel');
      allPanels.forEach(function (p) {
        p.classList.remove('is-active');
        p.style.opacity = '';
      });
      if (primaryMenuPanel) primaryMenuPanel.style.opacity = '1';
    });
    var ul = document.createElement('ul');
    panel.appendChild(backBtn);
    panel.appendChild(ul);
    /* Paneli tema sırasına göre yerleştir: primary (0) sonrası, bu menü öğesinin sıra numarasına göre.
     * Tema Liquid'de panelleri menü link sırasıyla oluşturuyor; aynı sırayı kullanınca global.js ve CSS ile uyumlu kalır. */
    var itemIndex = Array.prototype.indexOf.call(primaryList.children, targetLi);
    if (itemIndex === -1) itemIndex = 0;
    var insertBeforeEl = drawer.children[itemIndex + 1] || null;
    drawer.insertBefore(panel, insertBeforeEl);
    return panel;
  }

  /** Tek bir drawer paneline mega menü içeriğini enjekte et (yoksa). Tıklanırken içerik eksikse doldurur. */
  function ensureDrawerPanelContent(drawerPanel, handle) {
    if (drawerPanel.querySelector('.custom-megamenu-drawer-injected')) return;
    var desktopPanel = null;
    getPanels().forEach(function (p) {
      var h = p.getAttribute('data-menu-handle') || (p.getAttribute('data-megamenu-trigger') && toHandle(p.getAttribute('data-megamenu-trigger')));
      if (h === handle) desktopPanel = p;
    });
    if (!desktopPanel) return;
    var contentSource = desktopPanel.querySelector('.custom-megamenu-panel__content');
    if (!contentSource) return;
    var container = drawerPanel.querySelector('ul');
    if (!container) return;

    var wrap = document.createElement('div');
    wrap.className = 'custom-megamenu-drawer-injected custom-megamenu-panel__content';
    wrap.setAttribute('data-megamenu-drawer', 'true');
    var aspectRatio = desktopPanel.getAttribute('data-aspect-ratio') || '1';
    var mobileColumns = desktopPanel.getAttribute('data-mobile-columns') || '2';
    wrap.style.setProperty('--megamenu-media-aspect-ratio', aspectRatio);
    wrap.appendChild(contentSource.cloneNode(true));
    var grid = wrap.querySelector('.custom-megamenu-panel__grid');
    if (grid) grid.style.setProperty('--megamenu-columns', mobileColumns);
    container.parentNode.replaceChild(wrap, container);
  }

  /** Mobil drawer'da custom mega menü içeriğini (görseller + başlıklar) ilgili panele enjekte et */
  function injectMegamenuIntoDrawer() {
    var drawer = document.querySelector('header-drawer .menu-panels, .header__drawer .menu-panels');
    if (!drawer) return;

    getPanels().forEach(function (panel) {
      var handle = panel.getAttribute('data-menu-handle');
      var trigger = panel.getAttribute('data-megamenu-trigger');
      if (!handle && !trigger) return;
      if (!handle && trigger) handle = toHandle(trigger);
      if (!handle) return;

      var drawerPanel = drawer.querySelector('.menu-panel[data-menu="' + handle + '"]');
      if (!drawerPanel && trigger) {
        var altHandle = toHandle(trigger);
        if (altHandle) drawerPanel = drawer.querySelector('.menu-panel[data-menu="' + altHandle + '"]');
      }
      if (!drawerPanel) {
        drawerPanel = ensureDrawerPanelAndButton(drawer, handle, trigger);
      }
      if (!drawerPanel) return;

      var contentSource = panel.querySelector('.custom-megamenu-panel__content');
      if (!contentSource) return;

      var ul = drawerPanel.querySelector('ul');
      if (!ul) return;

      /* Zaten enjekte ettikse tekrar etme */
      if (drawerPanel.querySelector('.custom-megamenu-drawer-injected')) return;

      var wrap = document.createElement('div');
      wrap.className = 'custom-megamenu-drawer-injected custom-megamenu-panel__content';
      wrap.setAttribute('data-megamenu-drawer', 'true');
      var aspectRatio = panel.getAttribute('data-aspect-ratio') || '1';
      var mobileColumns = panel.getAttribute('data-mobile-columns') || '2';
      wrap.style.setProperty('--megamenu-media-aspect-ratio', aspectRatio);
      wrap.appendChild(contentSource.cloneNode(true));
      var grid = wrap.querySelector('.custom-megamenu-panel__grid');
      if (grid) grid.style.setProperty('--megamenu-columns', mobileColumns);
      ul.parentNode.replaceChild(wrap, ul);
    });
  }

  function init() {
    const panels = getPanels();
    const navItems = getNavItems();

    /* Menü kapalıyken header şeffaf: sınıfı kaldır */
    closeAllAndResetHeader();

    panels.forEach(function (panel) {
      const trigger = normalizeTrigger(panel.getAttribute('data-megamenu-trigger'));
      if (!trigger) return;
      const triggerNorm = normalizeForMatch(trigger);

      for (let i = 0; i < navItems.length; i++) {
        const item = navItems[i];
        const menuItem = item.getAttribute('data-menu-item');
        if (normalizeForMatch(menuItem) === triggerNorm) {
          bindPanelToNavItem(panel, item);
          break;
        }
      }
    });

    /* Menü bölgesinden (header + paneller) tamamen çıkınca kapat; panele gidiyorsa kapatma */
    var headerGroup = document.querySelector('.shopify-section-group-header-group');
    if (headerGroup) {
      headerGroup.addEventListener('mouseleave', function (e) {
        var related = e.relatedTarget;
        if (related && headerGroup.contains(related)) return;
        if (related && isMovingToMegamenuArea(related)) return;
        closeAllAndResetHeader();
      });
    }

    /* Tam yükleme sonrası header şeffaf kalsın (diğer scriptlerden kalan sınıf temizlensin) */
    window.addEventListener('load', function () {
      if (!megaNav.querySelector('.js-dropdown.is-visible') && !document.querySelector('.js-custom-megamenu-panel.is-visible')) {
        header.classList.remove('is-megamenu-open');
      }
    });

    /* Mobil drawer'da Şapka (ve diğer custom mega menülü öğeler) altında mega menü içeriği göster */
    injectMegamenuIntoDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('shopify:section:load', init);
})();
